import { CommonBaseData } from "../shared/data/common-base-data";
import { CommonSelectedData } from "../shared/data/common-selected-data";
import { N201A01OutData } from "../shared/webapi-data/n201a01-out-data";
import { N201A02OutData } from "../shared/webapi-data/n201a02-out-data";
import { N201A04OutData } from "../shared/webapi-data/n201a04-out-data";
import { N202A01OutData } from "../shared/webapi-data/n202a01-out-data";
import { N202A02OutData } from "../shared/webapi-data/n202a02-out-data";
import { N202A03OutData } from "../shared/webapi-data/n202a03-out-data";
import { N202A04OutData } from "../shared/webapi-data/n202a04-out-data";
import { N202A05OutData } from "../shared/webapi-data/n202a05-out-data";
import { N202A07OutData } from "../shared/webapi-data/n202a07-out-data";
import { N201A02OutOkurisakirisutoData } from "../shared/webapi-data/n201a02-out-okurisakirisuto-data";
import { N202A01OutEigyoshorisutoData } from "../shared/webapi-data/n202a01-out-eigyoshorisuto-data";
import { N202A01OutOtokuisakirisutoData } from "../shared/webapi-data/n202a01-out-otokuisakirisuto-data";
import { N202A01OutTokuyakutensamarisutoData } from "../shared/webapi-data/n202a01-out-tokuyakutensamarisuto";
import { N202A01OutBirudarisutoData } from "../shared/webapi-data/n202a01-out-birudarisuto-data";
import { N202A08OutData } from "../shared/webapi-data/n202a08-out-data";

export class N202MainData extends CommonBaseData {
  // 表示区分
  public initialKbn: string;
  // 受注No.
  public juchuno: string;
  // エラーリターンコード
  public errRtnCode: string;
  // 会社名
  public kaishamei: string;
  // 商品区分
  public shohinkubun: string;
  // ニチハ営業所
  public nichihaeigyosho: string;
  // ニチハ営業所リスト
  public eigyoshorisuto: N202A01OutEigyoshorisutoData[] = [];
  // お得意先
  public otokuisaki: string;
  // お得意先リスト
  public otokuisakirisuto: N202A01OutOtokuisakirisutoData[] = [];
  // 特約店
  public tokuyakuten: string;
  // 特約店様リスト
  public tokuyakutensamarisuto: N202A01OutTokuyakutensamarisutoData[] = [];
  // 代理店
  public urikakesakimei: string;
  // ビルダー
  public biruda: string;
  // ビルダーリスト
  public birudarisuto: N202A01OutBirudarisutoData[] = [];
  // 商流取得ＡＰＩ
  public shoryuApiOutData: N202A01OutData;
  // 配送形態
  public haisokeitai: string;
  // 宛名選択
  public atenasentaku: string;
  // 宛名リスト
  public okurisakirisuto: N201A02OutOkurisakirisutoData[] = [];
  // お届け先住所取得ＡＰＩ
  public atenaApiOutData: N201A02OutData;
  // 宛名入力
  public atenanyuryoku: string;
  // 郵便番号
  public yubimbango: string;
  // 都道府県
  public todofuken: string;
  // 都道府県リスト
  public selectedModel: CommonSelectedData[]; 
  // 住所1
  public jusho1: string;
  // 住所2
  public jusho2: string;
  // 配送ルート
  public haisoruto: string;
  // 荷量管理車種
  public niryokanrishashu: string;
  // 希望車種名
  public kiboshashumei: string;
  // 希望納期
  public kibonoki: string;
  // 引取希望時刻選択
  public hikitorikibojikokusentaku: string;
  // 引取希望時刻－表示用
  public hikitorikibojikokuhyojiyo: string;
  // お客様注文No.
  public okyakusamachumonno: string;
  // 連絡先氏名
  public renrakusakishimei: string;
  // 電話番号
  public denwabango: string;
  // 建築会社様名
  public kenchikukaishamei: string;
  // 物件名
  public bukkemmei: string;
  // 伝票用備考
  public dempyoyobiko: string;
  // 出荷用備考
  public shukkayobiko: string;
  // 用途
  public yoto: string;
  // 引取先取得ＡＰＩ
  public hikitoriApiOutData: N202A02OutData;
  // 発注入力業務チェックＡＰＩ
  public chekkuApiOutData: N202A03OutData;
  // 受注確定ＡＰＩ
  public kakuteiApiOutData: N202A04OutData;
  // 受注情報取得ＡＰＩ
  public juchuApiOutData: N202A05OutData;
  // 用途取得ＡＰＩ
  public yotoApiOutData: N202A07OutData;
  // ファイル
  public fileName: string;
  // 品番ＡＰＩ
  public himbanApiOutData: N201A01OutData;
  // 商品情報取得ＡＰＩ
  public shohinApiOutData: N201A04OutData;
  // 実品番取得ＡＰＩ
  public getHInbanApiOutData: N202A08OutData;
  // 品番
  public himban: string;
  // 郵便番号（引取先）
  public hikitorisakiyubimbango: string;
  // 県コード（引取先）
  public hikitorisakikenkodo: string;
  // 住所１（引取先）
  public hikitorisakijusho1: string;
  // 住所２（引取先）
  public hikitorisakijusho2: string;
  // 引取先名（引取先）
  public hikitorisakihikitorisakimei: string;
  // 出荷地（引取先）
  public hikitorisakishukkachi: string;
  // スルー拠点（引取先）
  public hikitorisakisurukyoten: string;
  // 総重量
  public sojuryo: number;
  // 総数量
  public sosuryo: number;
  // ユーザ名称
  public yuzamei: string;
  // messageParam
  //st-552 st-573 start
  // public messageParam: string;
  public messageParam: string[];
  //st-552 st-573 end
  public honjitsuHizuke: string;
  public honjitsuJikan: string;
  // ST-361 start
  // ダウンロード用ファイル名
  public downLoadFileName: string;
  // ST-361 end
  // 強化テスト No255 Start
  // 商品区分（商流）
  public shoryuShohinkubun: string;
  // 強化テスト No255 End
}



// WEBPACK FOOTER //
// ./src/app/modules/n202/n202-main-data.ts